/**
 * How a Signals-tab emitter is found, kept out of the row so it can be tested.
 */
import { MissionSignalEmitter } from '../../services/missionApi';

export function emitterMatchesQuery(
  emitter: MissionSignalEmitter,
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const hay = [
    emitter.name,
    emitter.identifier,
    emitter.normalized,
    emitter.kind,
    emitter.kind === 'ble' ? 'bluetooth' : '',
    emitter.own_kit ? 'own kit' : '',
    emitter.watchlisted ? 'watchlisted watchlist' : '',
    emitter.watchlist_label,
  ].filter(Boolean).join(' ').toLowerCase();
  return hay.includes(q);
}
